/* eslint-disable react/jsx-no-duplicate-props */
import React, { Component } from 'react'
import { Row, Col, Divider, Input, Button, Spin, Avatar, Tooltip } from 'antd'
import { FaReply, FaShare } from 'react-icons/fa'
import QMAction from '../../redux/quickMessage/actions'
// redux
import { connect } from 'react-redux'
import CKEditor from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import moment from 'moment'
import { Scrollbars } from 'react-custom-scrollbars'
import { IoIosMail } from 'react-icons/io'
import defaultImgEvent from '../../resource/image/imgEventDefaul.jpg'
import objectDefault from '../../resource/image/objectDefault.png'
import scrumBoardActions from '../../redux/scrumBoard/actions'
import objectAction from '../../redux/object/actions'
import mediaAction from '../../redux/qbmedia/actions'
import ReactQuill, { Quill } from 'react-quill'
import ReplyItem from './replyItem'
const default_avatar = require('../../resource/image/defaultUser.png')

class ShowMessage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            content: '',
            uid_receiver: 0,
            title: '',
            isShowReply: false,
        }
    }
    componentDidMount() {
        this.props.getCurrentListOrg()

        if (this.props.message.messid) {
            this.props.getListReplyInMess(this.props.message.messid)
        }
        if (this.props.message.media) {
            this.props.getListMediaQueryById(
                this.props.message.media.toString()
            )
        }
        if (this.props.message.event) {
            this.props.getListCurrentEvent(this.props.message.event.toString())
        }
        if (this.props.message.object) {
            this.props.getListObjectQueryById(
                this.props.message.object.toString()
            )
        }
        if (this.props.message && this.props.userInfo) {
            if (this.props.message.owner_id === this.props.userInfo.uid) {
                this.props.getInfoUidReceiver(this.props.message.receiver_uid)
            } else {
                this.props.getInfoUidReceiver(this.props.message.owner_id)
            }
        }
        console.log('get list media')
    }

    isReceiver = () => {
        if (this.props.message) {
            if (this.props.message.owner_id === this.props.userInfo.uid) {
                return 'Người nhận'
            } else {
                return 'Người gửi'
            }
        } else {
            return ''
        }
    }
    getTitle = () => {
        if (this.props.message) {
            if (this.props.message.owner_id === this.props.userInfo.uid) {
                return 'Báo cáo gửi đi'
            } else {
                return 'Báo cáo nhận về'
            }
        } else {
            return ''
        }
    }
    replyMessage = () => {
        const body = {
            content: this.state.content,
            messid: this.props.message.messid,
        }
        this.props.replyMessage(body)
        this.setState({ isShowReply: false })
    }

    getCurrentUserDisplay = () => {
        if (this.props.receiverInfo.length > 0) {
            return this.props.receiverInfo[0]
        } else {
            return {}
        }
    }
    getCurrentOrgDisplay = () => {
        if (this.props.listCrrOrg) {
            let crrOrg = this.props.listCrrOrg.find(org => {
                return org.oid === this.props.message.receiver_oid[0]
            })
            if (crrOrg) {
                return crrOrg
            }
        }
    }
    getnameOrg = oid => {
        if (this.props.listCrrOrg) {
            let crrOrg = this.props.listCrrOrg.find(org => {
                return org.oid === oid
            })
            if (crrOrg) {
                return crrOrg
            }
        }
    }

    componentWillReceiveProps(nextprops) {
        console.log('next props', nextprops)
        if (nextprops.message !== this.props.message && nextprops.message) {
            this.props.getListReplyInMess(nextprops.message.messid)
            if (nextprops.message.media) {
                this.props.getListMediaQueryById(
                    nextprops.message.media.toString()
                )
            }
            if (nextprops.message.event) {
                this.props.getListCurrentEvent(
                    nextprops.message.event.toString()
                )
            }
            if (nextprops.message.object) {
                this.props.getListObjectQueryById(
                    nextprops.message.object.toString()
                )
            }
            if (nextprops.message.receiver_uid && this.props.userInfo) {
                this.props.getInfoUidReceiverDone([])
                if (nextprops.message.owner_id === this.props.userInfo.uid) {
                    this.props.getInfoUidReceiver(
                        nextprops.message.receiver_uid
                    )
                } else {
                    this.props.getInfoUidReceiver(nextprops.message.owner_id)
                }
            }
        }
    }
    getId(url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
    }


    getContentToRender = (content) => {

        if (content.includes("<figure")) {
            try {
                let splitArr = content.split("<");
                let oembed = splitArr.find(vl => {
                    return vl.includes('oembed')
                })
                let urlList = oembed.split("oembed url=");
                let lastUrl = urlList[1].split(`"`)[1]
                const videoId = this.getId(lastUrl);
                const iframeMarkup = '<iframe src="//www.youtube.com/embed/'
                    + videoId + '" frameborder="0" allowfullscreen></iframe>';
                return iframeMarkup
            } catch (err) {
                return ""
            }

        } else {
            return content +
                `<p><br></p><p><br></p>`
        }
    }

    render() {
        const quillModules = {
            toolbar: false,
        }

        console.log('show message', this.props.lstReply)
        if (this.props.message) {
            return (
                <Scrollbars
                    span={20}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: 15,
                        height: window.innerHeight,
                    }}
                    autoHide
                >
                    <h3 style={{ paddingLeft: 10, color: '#a0c4a8' }}>
                        <IoIosMail style={{ marginRight: 5 }} size={30} />{' '}
                        {this.getTitle()}
                    </h3>
                    <h4 style={{ paddingLeft: 10, color: 'white' }}>
                        {this.props.message.title}
                    </h4>
                    {this.props.isloading && (
                        <div>
                            <Spin tip="Đang tải dữ liệu..."></Spin>
                        </div>
                    )}
                    {this.props.message.owner_id === this.props.userInfo.uid &&
                        (this.props.message.receiver_oid.length > 0 &&
                            this.getCurrentOrgDisplay() && (
                                <div style={{ marginBottom: 5, marginLeft: 5 }}>
                                    <Avatar
                                        size={48}
                                        src={
                                            this.getCurrentOrgDisplay().ext_data
                                                .avatarOrgani
                                        }
                                        style={{
                                            objectFit: 'contain',
                                        }}
                                    />
                                    <text
                                        style={{
                                            color: 'white',
                                            paddingLeft: 10,
                                        }}
                                    >
                                        {this.props.message.receiver_oid.map(
                                            (oid, index) => (
                                                <text>
                                                    {this.getnameOrg(oid).name}
                                                    {index ===
                                                        this.props.message.receiver_oid
                                                            .length -
                                                        1
                                                        ? ''
                                                        : ', '}
                                                </text>
                                            )
                                        )}
                                    </text>
                                </div>
                            ))}
                    {this.props.message.owner_id ===
                        this.props.userInfo.uid && (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    marginLeft: 5,
                                }}
                            >
                                <div style={{}}>
                                    <Avatar
                                        size={48}
                                        src={
                                            this.getCurrentUserDisplay().avatar ===
                                                ''
                                                ? default_avatar
                                                : this.getCurrentUserDisplay()
                                                    .avatar
                                        }
                                        style={{
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        color: 'white',
                                        paddingLeft: 10,
                                        paddingTop: 5,
                                        width: '100%',
                                    }}
                                >
                                    <text>
                                        {this.props.receiverInfo.map(
                                            (info, index) => (
                                                <text>
                                                    {info.display_name}
                                                    {index ===
                                                        this.props.receiverInfo.length -
                                                        1
                                                        ? ''
                                                        : ', '}
                                                </text>
                                            )
                                        )}
                                    </text>
                                    <ReactQuill
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            paddingRight: 10,
                                            marginTop: 10,
                                            borderWidth: 0,
                                            borderColor: 'transparent',
                                        }}
                                        id="divToPrint"
                                        modules={quillModules}
                                        readOnly
                                        value={
                                            this.getContentToRender(this.props.message.content)

                                        }
                                    />
                                </div>
                            </div>
                        )}

                    {this.props.message.owner_id !==
                        this.props.userInfo.uid && (
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    <Avatar
                                        size={48}
                                        src={
                                            this.getCurrentUserDisplay().avatar ===
                                                ''
                                                ? default_avatar
                                                : this.getCurrentUserDisplay()
                                                    .avatar
                                        }
                                        style={{
                                            padding: 5,
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        color: 'white',
                                        paddingLeft: 10,
                                        paddingTop: 5,
                                        width: '100%',
                                    }}
                                >
                                    <text>
                                        {this.props.receiverInfo.map(
                                            (info, index) => (
                                                <text>
                                                    {info.display_name}
                                                    {index ===
                                                        this.props.receiverInfo.length -
                                                        1
                                                        ? ''
                                                        : ', '}
                                                </text>
                                            )
                                        )}
                                    </text>
                                    <ReactQuill
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            paddingRight: 10,
                                            marginTop: 10,
                                            borderWidth: 0,
                                        }}
                                        id="divToPrint"
                                        modules={quillModules}
                                        readOnly
                                        value={
                                            this.getContentToRender(this.props.message.content)

                                        }
                                    />
                                </div>
                            </div>
                        )}
                    <Row style={{ margin: 10, color: 'white' }}>
                        <Col
                            span={8}
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            <text>Tài liệu liên quan</text>
                            {this.props.ListCurrentMedia.map(media => (
                                <a
                                    type="link"
                                    // href={media.url}
                                    target="_blank"
                                    onClick={() => {
                                        window.open(media.url, '_blank')
                                    }}
                                    block={false}
                                    style={{
                                        paddingLeft: 5,
                                        color: '#1a73e8',
                                        textDecorationLine: 'underline',
                                        paddingRight: 10,
                                    }}
                                >
                                    {media.name}
                                </a>
                            ))}
                        </Col>
                        <Col
                            span={8}
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            <text>Sự kiện liên quan</text>
                            <div style={{}}>
                                {this.props.ListCurrentEvent.map(event => (
                                    <Tooltip
                                        title={event.name}
                                        placement="bottom"
                                        key={event}
                                    >
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={`/app/qbevents/${event.event_id}`}
                                        >
                                            <Avatar
                                                shape="square"
                                                size={64}
                                                src={
                                                    event.avatar === ''
                                                        ? defaultImgEvent
                                                        : event.avatar
                                                }
                                                style={{
                                                    margin: 10,
                                                }}
                                            />
                                        </a>
                                    </Tooltip>
                                ))}
                            </div>
                        </Col>
                        <Col
                            span={8}
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            <text>Đối tượng liên quan</text>
                            <div style={{}}>
                                {this.props.ListCurrentObject.map(object => (
                                    <Tooltip
                                        title={object.name}
                                        placement="bottom"
                                        key={object}
                                    >
                                        <Avatar
                                            shape="square"
                                            size={64}
                                            src={
                                                object.avatar === ''
                                                    ? objectDefault
                                                    : object.avatar
                                            }
                                            style={{ margin: 10 }}
                                        />
                                    </Tooltip>
                                ))}
                            </div>
                        </Col>
                    </Row>
                    <Divider style={{ margin: 10 }} />

                    {this.props.lstReply.map(reply => (
                        <div>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        flex: 1,
                                        paddingRight: 20,
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}
                                    >
                                        <Avatar
                                            size={48}
                                            src={
                                                reply.avatar === ''
                                                    ? default_avatar
                                                    : reply.avatar
                                            }
                                            style={{
                                                padding: 5,
                                                objectFit: 'contain',
                                            }}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            color: 'white',
                                            paddingLeft: 10,
                                            paddingTop: 5,
                                        }}
                                    >
                                        <text>{reply.display_name}</text>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: this.getContentToRender(reply.content),
                                            }}
                                        />
                                        <ReplyItem data={reply} message={this.props.message} />
                                    </div>

                                </div>
                                <div
                                    style={{
                                        color: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: 150,
                                        fontSize: 13,
                                    }}
                                >
                                    <text>
                                        {moment(
                                            reply.created_time * 1000
                                        ).format('HH:mm - DD/MM/YYYY')}
                                    </text>
                                </div>
                            </div>
                            <Divider style={{ margin: 10 }} />
                        </div>
                    ))}
                    <div>
                        {!this.state.isShowReply && (
                            <Button
                                style={{ margin: 10 }}
                                onClick={() => {
                                    this.setState({ isShowReply: true })
                                }}
                            >
                                <FaReply style={{ paddingRight: 5 }} /> Trả lời
                            </Button>
                        )}
                        {this.state.isShowReply && (
                            <div>
                                <div style={{ padding: 10 }}>
                                    <text
                                        style={{
                                            color: 'white',
                                            fontSize: 14,
                                            marginBottom: 10,
                                        }}
                                    >
                                        <b>Đến: </b>{' '}
                                        {this.props.receiverInfo.map(
                                            (info, index) => (
                                                <text>
                                                    {info.display_name}
                                                    {index ===
                                                        this.props.receiverInfo
                                                            .length -
                                                        1
                                                        ? ''
                                                        : ', '}
                                                </text>
                                            )
                                        )}
                                        {/* {this.getCurrentUserDisplay().display_name} */}
                                    </text>
                                </div>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data=""
                                    onInit={editor => { }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData()
                                        this.setState({ content: data })
                                    }}
                                />
                                <Button
                                    style={{ margin: 10 }}
                                    onClick={this.replyMessage}
                                >
                                    <FaShare style={{ paddingRight: 5 }} />
                                    Gửi đi
                                </Button>
                            </div>
                        )}
                    </div>
                </Scrollbars>
            )
        } else {
            return <div></div>
        }
    }
}

const mapStateToProps = state => {
    return {
        listUser: state.QMreducer.listUser,
        userInfo: state.auth.userInfo,
        lstReply: state.QMreducer.lstReply,
        isloading: state.QMreducer.isloading,
        ListCurrentMedia: state.scrumBoard.ListCurrentMedia,
        ListCurrentEvent: state.scrumBoard.ListCurrentEvent,
        ListCurrentObject: state.scrumBoard.ListCurrentObject,
        receiverInfo: state.QMreducer.receiverInfo,
        listCrrOrg: state.QMreducer.listCrrOrg,
        listReplyInReply: state.QMreducer.listReplyInReply,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        getListuserByText: text => {
            dispatch(QMAction.action.getListuserByText(text))
        },
        getInfoUidReceiver: uid => {
            dispatch(QMAction.action.getInfoUidReceiver(uid))
        },
        sendMessage: (uid, body) => {
            dispatch(QMAction.action.sendMessage(uid, body))
        },
        replyMessage: body => {
            dispatch(QMAction.action.replyMessage(body))
        },
        getListReplyInMess: messid => {
            dispatch(QMAction.action.getListReplyInMess(messid))
        },
        getListMediaQueryById: id => {
            dispatch(mediaAction.action.getListMediaQueryById(id))
        },
        getListMediaQueryByIdDone: data => {
            dispatch(mediaAction.action.getListMediaQueryByIdDone(data))
        },
        getListCurrentEvent: id => {
            dispatch(scrumBoardActions.getListCurrentEvent(id))
        },
        getListCurrentEventDone: data => {
            dispatch(scrumBoardActions.getListCurrentEventDone(data))
        },

        getListObjectQueryById: id => {
            dispatch(objectAction.action.getListObjectQueryById(id))
        },
        getListObjectQueryById_done: data => {
            dispatch(objectAction.action.getListObjectQueryById_done(data))
        },
        getInfoUidReceiverDone: data => {
            dispatch(QMAction.action.getInfoUidReceiverDone(data))
        },
        getCurrentListOrg: () => {
            dispatch(QMAction.action.getCurrentListOrg())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShowMessage)
